import { AsyncState, Updater, loadingAsyncState, unloadedAsyncState } from "widgets-for-react"
import { getStaticMetadata } from "./metadate.api"
import { MetadataSetters } from "./metadata.utils"

export type Metadata = {
  title: string
  description: string
}

export type MetadataState = {
  data: AsyncState<Metadata | null>
  committed: boolean
}

export const initialMetadataState: MetadataState = {
  data: unloadedAsyncState(),
  committed: false
}

export const loadStaticMetadata = (s: AsyncState<Metadata | null>) => 
  s.kind == "unloaded" ? loadingAsyncState(() => getStaticMetadata()) : s

export const MetadataStateUpdaters = {
  data: (u: Updater<AsyncState<Metadata | null>>): Updater<MetadataState> => s => {
    const s1 = u(s.data)
    if (s1.kind == "loaded" && s1.value != null) {
      MetadataSetters.title(s1.value.title)
      MetadataSetters.description(s1.value.description)
      return { ...s, data: s1, committed: true }
    }
    return { ...s, data: s1 }
  }
}